module.exports = "pegasus/assets/blocks/social-1-theme6.png";